export function trackError(error: Parameters<typeof global.trackJs.track>[0]) {
  console.error(error);

  if (global.trackJs) {
    global.trackJs.track(error);
  }
}
